import { renderWalletsTab } from './tabs/walletsTab.js';
import { renderTransactionsTab } from './tabs/transactionsTab.js';
import { renderDashboardTab } from './tabs/dashboardTab.js';
import { renderStatsTab } from './tabs/statsTab.js';
import { renderSettingsTab } from './tabs/settingsTab.js';

export function initNavigation() {
    const navBtns = document.querySelectorAll('.nav-btn');
    const tabs = document.querySelectorAll('.tab-content');

    navBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            // Bỏ màu highlight của tất cả các nút
            navBtns.forEach(b => {
                b.classList.remove('text-primary');
                b.classList.add('text-gray-500');
            });
            
            // Thêm màu highlight cho nút vừa click
            btn.classList.add('text-primary');
            btn.classList.remove('text-gray-500');

            // Ẩn tất cả Tab nội dung
            tabs.forEach(tab => {
                tab.classList.remove('block', 'flex');
                tab.classList.add('hidden');
            });
            
            // Hiện Tab nội dung tương ứng
            const targetId = btn.getAttribute('data-target');
            const targetTab = document.getElementById(targetId);
            if(targetTab) {
                targetTab.classList.remove('hidden');
                if (targetId === 'tab-stats' || targetId === 'tab-settings') {
                    targetTab.classList.add('flex'); // stats and settings need flex-col
                } else {
                    targetTab.classList.add('block');
                }
            }
            

            // ĐIỀU HƯỚNG DỮ LIỆU: Bấm vào Tab nào thì lập tức tải dữ liệu của Tab đó
            if (targetId === 'tab-dash') {
                renderDashboardTab();
            } else if (targetId === 'tab-wallets') {
                renderWalletsTab();
            } else if (targetId === 'tab-txns') {
                renderTransactionsTab();
            } else if (targetId === 'tab-stats') {
                renderStatsTab();
            } else if (targetId === 'tab-settings') {
                renderSettingsTab();
            }
        });
    });
}
